import { Account } from "../Account/Account";

interface SidebarFooterProps {
  mini: boolean;
}

export function SidebarFooterAccount({ mini }: SidebarFooterProps) {
  return <Account variant={mini ? "condensed" : "expanded"} />;
}
